import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosClient from "@service/axiosClient";

export function useBlockedDays() {
  const qc = useQueryClient();
  const [error, setError] = useState<string | null>(null);
  const [newBlocked, setNewBlocked] = useState({
    date: "",
    part: "FULL",
    reason: "",
  });

  const { data: blockedDays = [] } = useQuery({
    queryKey: ["pto-blocked-days"],
    queryFn: async () => {
      const res = await axiosClient.get(`/api/admin/pto/blocked-days`);
      return res.data.blockedDays || [];
    },
  });

  const addBlockedMutation = useMutation({
    mutationFn: async ({
      date,
      part,
      reason,
    }: {
      date: string;
      part: string;
      reason: string;
    }) => {
      const res = await axiosClient.post(`/api/admin/pto/blocked-days`, {
        date,
        part,
        reason,
      });
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["pto-blocked-days"] }),
    onError: (e: any) => setError(e.message || "Failed to save blocked day"),
  });

  const deleteBlockedMutation = useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const res = await axiosClient.delete(`/api/admin/pto/blocked-days/${id}`);
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["pto-blocked-days"] }),
    onError: (e: any) => setError(e.message || "Failed to delete blocked day"),
  });

  return {
    blockedDays,
    newBlocked,
    setNewBlocked,
    error,
    setError,
    addBlockedMutation,
    deleteBlockedMutation,
  };
}
